"use client";

import { useState } from "react";
import "./ManufacturingSection.scss";
import Image from "next/image";
import Button from "@/components/Button/Button";
import { Col, Container, Row } from "react-bootstrap";
import ContactFormModal from "@/components/ContactFormModal/ContactFormModal";

const ManufacturingSection = ({ manufacturing }) => {
  const [showModal, setShowModal] = useState(false);
  const handleClick = () => {
    setShowModal(true);
  };

  if (!manufacturing) return null;

  const { title, description, ManufacturingData = [] } = manufacturing;
  return (
        <>
      <section className="manufacturing-service-section">
        <Container>
          <h2 className="manufacturing-title">
            {title}
          </h2>
          <p className="manufacturing-description">
            {description}
          </p>

          <Row className="g-4">
            {ManufacturingData.map((manufacturing) => (
              <Col key={manufacturing.id} xl={4} lg={4} md={6} sm={12}>
                <div className="manufacturing-card">
                  <div className="manufacturing-content">
                    <h5 className="manufacturing-name">
                      {manufacturing.title}
                    </h5>
                  </div>

                  <div className="manufacturing-icon">
                    <Image
                      src={manufacturing.icon}
                      alt={manufacturing.title}
                      className="manufacturing-img img-fluid"
                      width={50}
                      height={50}
                    />
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>

        <div className="text-center">
          <Button
            variant="primary"
            size="lg"
            className="action-btn"
            onClick={handleClick}
          >
            Get Started
          </Button>
        </div>
        <ContactFormModal
          show={showModal}
          onClose={() => setShowModal(false)}
          onConfirm={() => setShowModal(false)}
        />
      </section>
    </>
  );
};

export default ManufacturingSection;
